<template>
  <v-menu location="bottom end" offset="6">
    <template #activator="{ props }">
      <v-btn v-bind="props" variant="text" class="px-2" aria-label="Language">
        <span
          class="fi flag-rect"
          :class="flagClass(flagFor(locale))"
          aria-hidden="true"
        ></span>
        <v-icon size="16" class="ml-1">mdi-menu-down</v-icon>
      </v-btn>
    </template>

    <v-sheet class="lang-sheet" elevation="8" rounded="lg">
      <div class="flag-menu">
        <button
          v-for="l in otherLocales"
          :key="l"
          type="button"
          class="flag-btn"
          :aria-label="l"
          @click="selectLang(l)"
        >
          <span
            class="fi flag-rect flag-sm"
            :class="flagClass(flagFor(l))"
            aria-hidden="true"
          ></span>
        </button>
      </div>
    </v-sheet>
  </v-menu>
</template>

<script setup>
import { computed, watch } from 'vue'
import i18n, { setLocale } from '@/plugins/i18n'
import { useI18n } from 'vue-i18n'
import apiClient from '/api.js'
import { useAuthStore } from '/auth.js'
import { useSnackbarStore } from '@/stores/snackbarStore'

const { t, locale } = useI18n()
const auth = useAuthStore()
const snackbar = useSnackbarStore()

const LANGS = computed(() =>
  i18n.global.availableLocales?.length ? i18n.global.availableLocales : ['cs','en']
)
const otherLocales = computed(() => LANGS.value.filter(l => l !== locale.value))


const FLAG_MAP = { cs: 'cz', en: 'gb', ua: 'uk' }
const flagFor = (l) => (FLAG_MAP[l] || l.slice(0,2)).toLowerCase()
const flagClass = (cc) => `fi-${cc}`

function selectLang(l) {
  if (l !== locale.value) setLocale(l)
}

watch(() => locale.value, async (newLang, oldLang) => {
  if (newLang === oldLang) return
  try {
    await apiClient.put('account/', { language_code: newLang })
    auth.persistLocale(newLang)
    snackbar.success(t('messages.updated'))
  } catch (e) { console.error(e) }
})
</script>

<style scoped>
/* jednotné rozměry + jemný ring pro kontrast */
.flag-rect{
  width:24px; height:18px; border-radius:3px;
  box-shadow: 0 0 0 1px rgba(0,0,0,.18);
  filter: drop-shadow(0 1px 1px rgba(0,0,0,.1));
}
.flag-sm{ width:24px; height:18px; }

.lang-sheet{ background:#fff; padding:3px; min-width:60px; }
.flag-menu{ display:flex; flex-direction:column; gap:6px; }

.flag-btn{
  width:100%; background:none; border:0; padding:12px 16px;
  display:flex; justify-content:center; align-items:center;
  border-radius:8px; cursor:pointer;
}
.flag-btn:hover{ background:#f5f5f7; }

@media (max-width: 600px){
  .lang-sheet{ padding:10px 12px; min-width:84px; }
  .flag-menu{ gap:10px; }
  .flag-btn{ padding:12px 14px; border-radius:10px; }
  .flag-sm{ width:28px; height:21px; } /* lehce větší na touch */
}
</style>
